import { z } from 'zod';
import { Priority } from '../../constants/priority.js';
/** One rung of the priority ladder, shared by every place a priority is chosen. */
export const priorityIdSchema = z.enum(Priority, 'Choose a priority from the list.');
//# sourceMappingURL=priority-id.js.map